// USUARIO LIMITADO: nao e administrador/motorista e so recebeu as permissoes dos lancamentos manuais e/ou da tela simples de veiculos.
// E o espelho da regra do SERVIDOR (que e quem de fato bloqueia o resto): aqui so decide o que mostrar no menu e em que tela abrir.
export const ITEM_LANCAMENTO = 'lancamento_manual'
export const ITEM_VEICULOS = 'ativos_simples'
export const ITENS_LIMITADOS = [ITEM_LANCAMENTO, ITEM_VEICULOS]

export function ehLimitado(u: any): boolean {
  if (!u || ['superadmin', 'admin', 'motorista'].includes(u.perfil)) return false
  return Array.isArray(u.permissoes) && u.permissoes.length > 0 && u.permissoes.every((i: string) => ITENS_LIMITADOS.includes(i))
}

// telas (ids do menu) que o usuario limitado enxerga
export function paginasLimitado(u: any): string[] {
  if (!ehLimitado(u)) return []
  return [...(u.permissoes.includes(ITEM_LANCAMENTO) ? ['lancamentos'] : []), ...(u.permissoes.includes(ITEM_VEICULOS) ? ['meus_veiculos'] : [])]
}

export function paginaInicialLimitada(u: any): string | null {
  const p = paginasLimitado(u)
  return p.length ? p[0] : null
}
